(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/announcement/assets/javascripts/announcement.js') >= 0) return;  svs.modules.push('/widgets/announcement/assets/javascripts/announcement.js');

'use strict';

svs = svs || {};

const logger = new svs.core.log.Logger('widget:announcement');

let _lastDialogSignature = null;
let _lastDialogAt = 0;
const _SUPPRESS_WINDOW_MS = 1000;
function _buildDialogSignature(a) {
  try {
    if (!a) {
      return 'empty';
    }
    return JSON.stringify({
      id: a.id || a.title || '',
      t: a.title || '',
      ty: a.type || '',
      m: a.message || a.content || '',
      b: (a.buttons && a.buttons[0] && a.buttons[0].text) || ''
    });
  } catch (_) {
    return 'error';
  }
}

svs.widget = svs.widget || {};
svs.widget.announcement = svs.widget.announcement || {};
svs.widget.announcement.init = function(model) {
  try {

    let anns;
    if (model && model.model && Array.isArray(model.model.announcements)) {
      anns = model.model.announcements;
    } else if (model && Array.isArray(model.announcements)) {
      anns = model.announcements;
    } else {
      anns = [];
    }

    if (!anns.length) {
      logger.debug('No announcements passed to init, skipping');
      return;
    }

    const announcement = anns[0] || {};

    if (!svs.ui || !svs.ui.dialog || !svs.ui.dialog.Confirm) {
      logger.warn('Dialog component unavailable, cannot show announcement dialog');
      return;
    }

    const sig = _buildDialogSignature(announcement);
    const now = Date.now();
    if (sig && _lastDialogSignature === sig && (now - _lastDialogAt) < _SUPPRESS_WINDOW_MS && !(model && model.force === true)) {
      logger.debug('Duplicate announcement dialog suppressed');
      return;
    }
    _lastDialogSignature = sig;
    _lastDialogAt = now;

    const tenant = (svs.core && svs.core.detect && typeof svs.core.detect.tenant === 'function' && svs.core.detect.tenant('lb')) ? 'SPORT' : 'TUR';
    const branding = (svs.ui.dialog && svs.ui.dialog.branding && svs.ui.dialog.branding[tenant]) || undefined;
    const type = (svs.ui.dialog && svs.ui.dialog.type && svs.ui.dialog.type.ERROR) || undefined;

    const dialog = new svs.ui.dialog.Confirm({
      branding: branding,
      type: type,
      title: announcement.title || '',
      message: [
        {
          type: svs.ui.dialog.message.TEXT,
          text: announcement.message || announcement.content || ''
        }
      ],
      actions: [
        {
          title:
            (announcement.buttons && announcement.buttons[0] && announcement.buttons[0].text) || 'Okej'
        }
      ]
    });

    svs.ui.dialog.api.add(dialog);
    logger.info('Announcement dialog shown', { title: announcement.title });
  } catch (e) {
    try {
      logger.error('Error in announcement.init', e && (e.message || (e.toString && e.toString())));
    } catch (_) {
    }
  }
};



 })(window);